<template>
  <div class="grid grid-cols-12">
    <div class="col-span-12 col-start-1 md:col-span-8 md:col-start-3">
      <div class="max-w-3xl mx-auto text-center font-gotham-bold">
        <Title :title="header.headline" :centered="true" />
        <p class="mt-4 text-lg text-brand-secondary font-gotham-bold">{{header.tagline}}</p>
      </div>

      <dl class="mt-12 space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 lg:grid-cols-4 lg:gap-x-8">
        <div v-for="feature in features" :key="feature.name" class="relative items-center text-center">
          <dt class="flex flex-col items-center">
            <img :src="feature.img" class="text-center items-center">
            <p class="text-2xl h-20 pt-4 leading-6 font-gotham-bold text-brand-primary ">{{ feature.name }}</p>
          </dt>
          <dd class="mt-2 font-gotham-medium text-gray-700">
            {{ feature.description }}
          </dd>
        </div>
      </dl>
    </div>
  </div>
</template>

<script setup lang="ts">
import Title from './Title.vue';
import { defineProps } from 'vue';

type FeaturesData = {
  features: Array<{
    name: string,
    description: string,
    img?: string,
    imghover: string
  }>,
  header: {
    headline: string,
    tagline: string
  }
}

defineProps<FeaturesData>();

</script>
